import router from "@/router"
import httpRequest from '@/services/httpRequest.js'
import users from '@/services/users.js'

export default ({
  namespaced: true,
  state: {
    recruitmentData: null,
    recruitmentList: [],
    registrantList: [],
    recruitmentItem: {},
    showSuccessRecruitmentModal: false,
    captcha: null,
    errorSubmitForm: null,
    studentRecruitmentData: null,
    recruitment: null,
    isLoading: false,
    popUpTitle: null,
    popUpDescription: null
  },
  mutations: {
    SET_RECRUITMENT(state, data) {
      state.recruitmentData = data
    },
    SET_RECRUITMENT_LIST(state, data) {
      state.recruitmentList = data;
    },
    ADD_TO_RECRUITMENT_LIST(state, data) {
      state.recruitmentList = [...state.recruitmentList, ...data];
    },
    SET_REGISTRANT_LIST(state, data) {
      state.registrantList = data
    },
    ADD_TO_REGISTRANT_LIST(state, data) {
      state.registrantList = [...state.registrantList, ...data];
    },
    SET_CAPTCHA(state, data) {
      state.captcha = data
    },
    SET_STUDENT_RECRUITMENT(state, data) {
      state.studentRecruitmentData = data.results[0]
    },
  },
  getters: {
    keyValueStages: (state) => {
      let stages = [{
        key: '',
        label: 'Semua Tahapan',
      }];

      state.recruitmentItem.stages.forEach((stage) => {
        stages.push({
          key: stage.id,
          label: stage.name
        })
      })
      return stages
    },
  },
  actions: {
    async getListRecruitment({ rootState, commit }, { param, page = 1, pageSize = 10, isLoadMore = false }) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/recruitment`,
          method: 'GET',
          params: {
            ...param,
            page: page,
            rows: pageSize,
          },
        },
        authorized: true
      }

      const res = await httpRequest(payload)

      if (res.status === 200) {
        const results = res.data.results

        if (isLoadMore) {
          await commit('ADD_TO_RECRUITMENT_LIST', res.data.results)
        } else {
          await commit('SET_RECRUITMENT_LIST', res.data.results)
        }
        rootState.isLoading = false
        return { results, status: 'success' };
      } else {
        rootState.isLoading = false
        //console.log('error = ', res)
        return { results: [], status: 'error' };
      }
    },

    async getListRegistrant({ rootState, state, commit }, { param, page = 1, pageSize = 10, isLoadMore = false }) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/recruitment_student`,
          method: 'GET',
          params: {
            ...param,
            page: page,
            rows: pageSize,
          },
        },
        authorized: true
      }

      const res = await httpRequest(payload)

      if (res.status === 200) {
        const results = res.data.results || []

        if (isLoadMore) {
          const newList = [...state.registrantList, ...results];
          // await commit('ADD_TO_REGISTRANT_LIST', res.data.results)
          await commit('SET_REGISTRANT_LIST', newList)
        } else {
          await commit('SET_REGISTRANT_LIST', results)
        }
        rootState.isLoading = false
        return { results };
      } else {
        rootState.isLoading = false
        //console.log('error = ', res)
        // return { results: [] }
      }
    },

    async isAvailableRecruitment({ rootState }) {
      const payload = {
        options: {
          url: `${rootState.auth.schoolData.domain}/api/v1/recruitment/available`,
          method: 'GET'
        },
        authorized: false
      }

      const res = await httpRequest(payload)

      if (res.status === 200) {
        if (res.data.id) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },

    async goToRecruitmentForm({ rootState, commit }, url) {
      const payload = {
        options: {
          url: `${rootState.auth.schoolData.domain}/api/v1/recruitment/available`,
          method: 'GET'
        },
        authorized: false
      }

      const res = await httpRequest(payload)
      if (res.status === 200) {
        await commit('SET_RECRUITMENT', res.data)
        rootState.isLoading = false
        if (url) {
          router.push({ path: url })
        } else {
          rootState.auth.switchAccountState = 'recruitment'
        }
      } else {
        rootState.isLoading = false
        //console.log('error = ', res)
      }
    },

    async getCaptcha({ rootState, commit }) {
      const payload = {
        options: {
          url: `${rootState.auth.schoolData.domain}/api/get_captcha`,
          method: 'GET'
        },
        authorized: false
      }

      const res = await httpRequest(payload)
      if (res.status === 200) {
        await commit('SET_CAPTCHA', res.data)
      }
    },

    async submitForm({ commit, rootState, state }, data) {
      const payload = {
        options: {
          url: `${rootState.auth.schoolData.domain}/api/v1/recruitment_student`,
          method: 'POST',
          data: data
        },
        authorized: false
      }

      const res = await httpRequest(payload)

      if (res.status === 201) {
        rootState.isLoading = false
        state.showSuccessRecruitmentModal = true
      } else if (res.status === 400) {
        //console.log('res = ', res)
        state.errorSubmitForm = res.data[0]
        if (res.data.captcha) {
          state.errorSubmitForm = res.data.captcha[0]
        }
        rootState.isLoading = false
      } else {
        //console.log('GAGAL = ', res)
        rootState.isLoading = false
      }
    },

    async getStudent({ rootState, commit }) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/recruitment_student`,
          method: 'GET'
        },
        authorized: true
      }

      const res = await httpRequest(payload)

      if (res.status === 200) {
        commit('SET_STUDENT_RECRUITMENT', res.data)
      } else if (res.status === 404) {
        return
      } else {
        return
      }
    },

    async getStage({ rootState, commit, state }, recruitment) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/recruitment/${recruitment}`,
          method: 'GET'
        },
        authorized: true
      }

      const res = await httpRequest(payload)

      if (res.status === 200) {
        commit('SET_RECRUITMENT', res.data)
        state.isLoading = false
      } else {
        state.isLoading = false
      }
    },

    async postAttachment({ commit, rootState, dispatch }, data) {
      const token = await users.getToken()
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/recruitment_student/${data.id}`,
          method: 'PATCH',
          data: data.payload
        },
        authorized: true
      }

      //console.log('postAttachment payload = ', payload)

      const res = await httpRequest(payload)

      if (res.status === 200) {
        //console.log('success', res)
        rootState.showPopUpModal = true
        rootState.popUpModalTitle = 'Berhasil'
        rootState.popUpModalDescription = 'Berhasil ubah data'
        rootState.popUpModalIsSuccess = true
        dispatch('getStudent')
        rootState.isLoading = false
        //commit('SET_RECRUITMENT', res.data)
      } else {
        rootState.isLoading = false
      }
    },

    async submitBiodata({ rootState, commit, state }, data) {
      //console.log('sybmit = ', data)
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/recruitment_student/${data.no_recruitment}`,
          method: 'PATCH',
          data: data
        },
        authorized: true
      }

      const res = await httpRequest(payload)

      if (res.status === 200) {
        rootState.showPopUpModal = true
        rootState.popUpModalTitle = 'Berhasil'
        rootState.popUpModalDescription = 'Berhasil ubah data'
        rootState.popUpModalIsSuccess = true
        commit('SET_STUDENT_RECRUITMENT', { results: [res.data] })
        rootState.isLoading = false
      } else if (res.status === 400) {
        state.errorSubmitForm = res.data[0]
        if (res.data.captcha) {
          state.errorSubmitForm = res.data?.captcha[0]
        }
      } else {
        //console.log('GAGAL = ', res)
      }
    }
  }
})